import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function Greeting() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 text-center">
      <h1 className="greeting">  ## Pick a ChildCare app ## - coming soon!</h1>
         <h4 className="text-2xl sm:text-5xl font-bold text-blue bg-black/40 backdrop-blur-md px-8 
         py-4 rounded-2xl shadow-6xl text-center border border-white/10 tracking-tight">
              A free directory of daycares and home-based childcares
            </h4> 
            <h4> -- </h4>
             <h4 className="text-2xl sm:text-5xl font-bold text-blue bg-black/40 backdrop-blur-md px-8 
         py-4 rounded-2xl shadow-6xl text-center border border-white/10 tracking-tight">
              Providers can list their profiles, create waitlists, and manage open spots
            </h4> 
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <Greeting />
   <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();